var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M41 1H1V6H14.3333H27.6667H41V1Z",
    fill: "#D0D7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bright-stroke",
    d: "M1 1H41M1 1V41H41V1M1 1V6M41 1V6M1 6H41M1 6H14.3333M41 6H27.6667M14.3333 6V17.67M14.3333 6H27.6667M14.3333 17.67V29.335M14.3333 17.67H1M14.3333 17.67H27.6667M14.3333 29.335V41M14.3333 29.335H1M14.3333 29.335H27.6667M27.6667 6V17.67M27.6667 17.67V29.335M27.6667 17.67H41M27.6667 29.335V41M27.6667 29.335H41",
    stroke: "#D0D7DE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable02);
export default __webpack_public_path__ + "static/media/table-02.7be3dbb3a7f252ea35cb0d7e57439fad.svg";
export { ForwardRef as ReactComponent };